import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

export type CboSearchNoResultsFoundProps = {
  searchTerm: string;
};

export const CboSearchNoResultsFound = ({
  searchTerm,
}: CboSearchNoResultsFoundProps) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <IconSymbol icon="search" size={48} color="$core.color.brand.100"/>
      <h3>
        {' '}
        We're sorry!  We couldn't find any programs in your area related to{' '}
        "{searchTerm}".
      </h3>
      <p>
        {' '}
        Try broadening your search, adjusting your filters, or starting with the
        commonly searched categories above.
      </p>
      <ul style={{ display: 'inline-block', textAlign: 'left', marginTop: '8px', listStyleType: 'disc', paddingLeft: '20px' }}>
        <li>Try searching a new category</li>
        <li>Try a different location</li>
        <li>Try adjusting your filters</li>
      </ul>
    </div>
  );
};
